import React from 'react'

const Chats = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className='immersion__chats'>
            {children}
        </div>
    )
}

export default Chats